import { useQuery } from 'react-query';
import { api } from '../services/api';

const basePath = 'debts';

export interface IMandatoryDebt {
  additionalDescription: string;
  consultNumber: string;
  debtsCode: number;
  description: string;
  price: number;
  type: string;
}

export interface IDebts {
  vehiclePlate: string;
  vehicleUF: string;
  totalMandatory: number;
  driverName?: string;
  expirationDate: string;
  onCheck: {
    unSelect: IMandatoryDebt[];
    select: IMandatoryDebt[];
  };
  consultName: string;
  dueDate: string;
  issuer: string;
  subUser: string;
  debtsCode: number;
  consultDate: string;
  createdAt: string;
  isExpired: boolean;
  onUnCheck: {
    unSelect: IMandatoryDebt[];
    select: IMandatoryDebt[];
  };
  isDuplicated: boolean;
  disabled: string;
  correlationId: string;
  uniqueId: string;
  description: string;
  price: number;
  consultNumber: string;
  additionalDescription?: string;
  type: string;
}

export interface IGetDebtsResult {
  data: IDebts[];
  total: {
    ipva?: number,
    licenciamento?: number,
    multas?: number,
    outros?: number
  };
  meta: {
    page: number;
    take: number;
    itemCount: number;
    pageCount: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
  };
}

export interface IGetDebtsParams {
  duplicated?: boolean;
  order?: string;
  page?: number;
  take?: number;
  sub?: string;
}

export const getDebts = async (
  params: IGetDebtsParams,
): Promise<IGetDebtsResult> => {
  const { data } = await api.get(basePath, { params });
  return data;
};

export function useDebtsInfo(params: IGetDebtsParams) {
  params.order = params.order?.toUpperCase();
  params.sub = 'a8e0e969-f159-43e4-9b5e-b08d7dff04ca';
  const queryKey = [
    basePath,
    params.duplicated,
    params.sub,
    params.order,
    params.page,
    params.take,
  ];

  return useQuery(queryKey, () => getDebts(params), {
    staleTime: 60000,
  });
}
